export default __webpack_public_path__ + "static/media/share-whatsapp-icon.fa4bed9d.png";